import React, { FC } from 'react';

interface TableBodyProps {
  children: React.ReactNode;
}

const TableBody: FC<TableBodyProps> = ({ children }) => {
  return <tbody>{children}</tbody>;
};

export default TableBody;
